import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=0be5ea66&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "./Content.vue?vue&type=style&index=0&id=0be5ea66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5ea66",
  null
  
)

export default component.exports